export function isMeusPagamentosAssinatura (assinaturaId) {
  return true
}
